export interface PreguntaFrecuente {
  id: number;
  categoria: string | null;
  pregunta: string;
  respuesta: string;
  orden: number;

  publicada: boolean;
  actualizadoEn: string | null;
  actualizadoPor: string | null;
}

export interface DatosDePregunta {
  categoria: string | null;
  pregunta: string;
  respuesta: string;
  orden: number;
  publicada: boolean;
}

export interface BannerDelPortal {
  id: number;

  texto: string;

  enlace: string | null;
  orden: number;
  publicado: boolean;

  desde: string | null;
  hasta: string | null;
  tipo: string;

  version: string;
  pesoGrande: number;
  pesoMovil: number;
  actualizadoEn: string | null;
  actualizadoPor: string | null;
}

export interface DatosDeBanner {
  texto: string;
  enlace: string | null;
  orden: number;
  publicado: boolean;
  desde: string | null;
  hasta: string | null;
}

export interface ContactoDelPortal {
  telefono: string | null;

  telefonoMarcable: string | null;
  correo: string | null;
  direccion: string | null;

  horario: string | null;
  facebook: string | null;
  instagram: string | null;
  tiktok: string | null;
  lema: string | null;
}

export interface ContactoConCambio {
  contacto: ContactoDelPortal;
  actualizadoEn: string | null;
  actualizadoPor: string | null;
}

export const PAGINAS_DE_LA_VENTANILLA: ReadonlyArray<{ ruta: string; nombre: string }> = [
  { ruta: '/consulta', nombre: 'Consultar deuda' },
  { ruta: '/mis-facturas', nombre: 'Mis facturas' },
  { ruta: '/mis-pagos', nombre: 'Mis pagos' },
  { ruta: '/registro', nombre: 'Crear mi cuenta' },
  { ruta: '/entrar', nombre: 'Entrar' },
  { ruta: '/preguntas-frecuentes', nombre: 'Preguntas frecuentes' },
  { ruta: '/sobre-nosotros', nombre: 'Sobre nosotros' },
  { ruta: '/', nombre: 'Inicio' },
];

export interface TipoDeDocumentoLegal {

  clave: string;
  nombre: string;
  descripcion: string;
}

export type EstadoDeDocumento = 'BORRADOR' | 'VIGENTE' | 'ANTERIOR';

export interface DocumentoLegal {
  id: number;
  tipo: string;
  titulo: string;
  version: string;

  aprobadoEl: string | null;
  nombreArchivo: string;
  peso: number;

  huella: string;
  estado: EstadoDeDocumento;
  publicadoEn: string | null;
  publicadoPor: string | null;
  retiradoEn: string | null;
  creadoEn: string;
  creadoPor: string | null;
}

export interface DocumentosLegales {
  tipos: TipoDeDocumentoLegal[];
  documentos: DocumentoLegal[];
}

export interface DatosDeDocumento {
  titulo: string;
  version: string;
  aprobadoEl: string | null;
}
